import React from 'react'
import { ShareMenu } from '../../../components/common/ShareMenu'
import './styles.scss'

const ReadHeader = (props) => {
  const { content } = props

  return (
    <section className='watch-header'>
      <div itemProp='image' itemScope itemType='http://schema.org/ImageObject'>
        <meta itemProp='height' content={content.header.miniature_height} />
        <meta itemProp='width' content={content.header.miniature_width} />
        <meta itemProp='url' content={content.header.miniature} />
      </div>

      <section className='share-buttons-container'>
        <ShareMenu
          title={content.header.title}
          intro={content.header.intro}
          tags={content.header.tags}
          section='Yok Radio'
        />
      </section>

      <section itemProp='publisher' itemScope itemType='http://schema.org/Organization'>
        <meta itemProp='url' content='https://yokradio.com/' />
        <meta itemProp='name' content='Yok Radio' />
        <div itemProp='logo' itemScope itemType='http://schema.org/ImageObject'>
          <meta itemProp='url' content='https://yokradio.com/assets/icon/android-chrome-1024x1024.png' />
        </div>
      </section>

      <h1
        itemProp='headline'
        className='title'
      >
        {content.header.title}
      </h1>
    </section>
  )
}

export default ReadHeader
